import {
  createEntityAdapter,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';
import { RootState } from 'state/store';
import { EventDrillDownItem } from 'types/store/normalized/insightsDrillDown';
import { JsonApiResource } from 'types/store/jsonApi';
import { DrilldownJsonApiResponse } from 'api/normalized/insightDrilldown/InsightDrilldownApi';
import { transformEventDrilldownData } from 'api/normalized/insightDrilldown/transformers';
import { EventDrillDownApiResponse } from 'api/normalized/insightDrilldown/types';

/* ============================== STATE SETUP =============================== */
const insightDrilldownEventsAdapter = createEntityAdapter<EventDrillDownItem>();

/* ================================= REDUCER ================================ */
const insightDrilldownEventsSlice = createSlice({
  name: 'normalized/insightDrilldownEvents',
  initialState: insightDrilldownEventsAdapter.getInitialState(),
  reducers: {
    addEvents: (
      state,
      action: PayloadAction<DrilldownJsonApiResponse['data']>
    ) => {
      const events = transformEventDrilldownData(
        action.payload as Array<JsonApiResource<EventDrillDownApiResponse>>
      );
      insightDrilldownEventsAdapter.setMany(state, events);
    },
  },
});

/* =============================== SELECTORS ================================ */
const defaultSelectors = insightDrilldownEventsAdapter.getSelectors<RootState>(
  (state) => state.normalized.insightDrilldownEvents
);

const selectEventsByIds = (
  state: RootState,
  ids: Array<string>
): Array<EventDrillDownItem> =>
  ids
    .map((id) => defaultSelectors.selectById(state, id))
    .filter((item) => !!item);

/* ================================ EXPORTS ================================= */
export const insightDrilldownEventsSelectors = {
  ...defaultSelectors,
  selectEventsByIds,
};
export const { addEvents } = insightDrilldownEventsSlice.actions;
export default insightDrilldownEventsSlice.reducer;
